import { FilePlus, FolderPlus, GitBranch, GitCommit, RefreshCw } from "lucide-react";
import { useState } from "react";

interface WorkspaceToolbarProps {
	onNewFile: () => void;
	onNewFolder: () => void;
	onGitInit: () => void;
	onGitCommit: () => void;
	onRefresh: () => void;
	gitEnabled?: boolean;
}

export function WorkspaceToolbar({
	onNewFile,
	onNewFolder,
	onGitInit,
	onGitCommit,
	onRefresh,
	gitEnabled,
}: WorkspaceToolbarProps) {
	const [showCommitInput, setShowCommitInput] = useState(false);
	const [commitMessage, setCommitMessage] = useState("");

	return (
		<div className="px-2 py-2 space-y-2">
			<div className="flex items-center gap-1">
				<button
					type="button"
					onClick={onNewFile}
					className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-[10px] font-medium rounded-md bg-secondary/50 hover:bg-secondary transition-colors"
					title="New file"
				>
					<FilePlus className="w-3 h-3" />
					<span className="hidden lg:inline">File</span>
				</button>
				<button
					type="button"
					onClick={onNewFolder}
					className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-[10px] font-medium rounded-md bg-secondary/50 hover:bg-secondary transition-colors"
					title="New folder"
				>
					<FolderPlus className="w-3 h-3" />
					<span className="hidden lg:inline">Folder</span>
				</button>
				<button
					type="button"
					onClick={onRefresh}
					className="p-1.5 rounded-md bg-secondary/50 hover:bg-secondary transition-colors"
					title="Refresh"
				>
					<RefreshCw className="w-3 h-3" />
				</button>
			</div>

			<div className="flex items-center gap-1">
				{gitEnabled ? (
					<button
						type="button"
						onClick={() => setShowCommitInput(!showCommitInput)}
						className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-[10px] font-medium rounded-md bg-secondary/50 hover:bg-secondary transition-colors"
						title="Git commit"
					>
						<GitCommit className="w-3 h-3" />
						<span className="hidden lg:inline">Commit</span>
					</button>
				) : (
					<button
						type="button"
						onClick={onGitInit}
						className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-[10px] font-medium rounded-md bg-secondary/50 hover:bg-secondary transition-colors"
						title="Git init"
					>
						<GitBranch className="w-3 h-3" />
						<span className="hidden lg:inline">Init Git</span>
					</button>
				)}
			</div>

			{showCommitInput && gitEnabled && (
				<div className="flex items-center gap-1">
					<input
						type="text"
						value={commitMessage}
						onChange={(e) => setCommitMessage(e.target.value)}
						placeholder="Commit message..."
						className="flex-1 px-2 py-1 text-[10px] rounded-md bg-secondary/50 border border-border outline-none"
						onKeyDown={(e) => {
							if (e.key === "Enter" && commitMessage.trim()) {
								onGitCommit();
								setCommitMessage("");
								setShowCommitInput(false);
							}
							if (e.key === "Escape") {
								setShowCommitInput(false);
							}
						}}
					/>
					<button
						type="button"
						onClick={() => {
							if (commitMessage.trim()) {
								onGitCommit();
								setCommitMessage("");
							}
							setShowCommitInput(false);
						}}
						className="p-1 rounded-md bg-primary text-primary-foreground hover:bg-primary/90"
					>
						<GitCommit className="w-3 h-3" />
					</button>
				</div>
			)}
		</div>
	);
}
